import type { FC, ReactNode } from 'react';

interface HelpCaptionDescriptionProps {
  children: ReactNode;
}

export const HelpCaptionDescription: FC<HelpCaptionDescriptionProps> = ({ children }) => {
  return <span className="font-weight-400 font-size-14 pt-0 pb-24">{children}</span>;
};
